module.exports = __webpack_public_path__ + "img/spring_trip-20160416-20.589a9112.jpg";